import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

// Initialize i18next with react-i18next
i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18next;
